import { disableScroll, enableScroll } from './utils/disableScroll';

const initMiniCart = () => {
  const $drawer = jQuery('.js-mini-cart-drawer');
  const $trigger = jQuery('.js-mini-cart-trigger');
  const $close = jQuery('.js-mini-cart-close');
  const $overlay = jQuery('.js-mini-cart-overlay');
  const $body = jQuery('body');

  if (!$drawer.length) {
    return;
  }

  const openDrawer = () => {
    $drawer.addClass('is-active');
    $overlay.addClass('is-active');
    $body.addClass('mini-cart-open');
    disableScroll();
  };

  const closeDrawer = () => {
    $drawer.removeClass('is-active');
    $overlay.removeClass('is-active');
    $body.removeClass('mini-cart-open');
    enableScroll();
  };

  // Open drawer on trigger click
  $trigger.on('click', (e) => {
    e.preventDefault();
    openDrawer();
  });

  // Open drawer on mobile cart toggle click
  jQuery('.js-cart-mobile-toggle').on('click', (e) => {
    e.preventDefault();
    openDrawer();
  });

  // Close drawer on close button click
  $close.on('click', (e) => {
    e.preventDefault();
    closeDrawer();
  });

  // Close drawer on overlay click
  $overlay.on('click', (e) => {
    if (jQuery(e.target).hasClass('js-mini-cart-overlay')) {
      closeDrawer();
    }
  });

  // Close drawer on ESC key
  jQuery(document).on('keydown', (e) => {
    if (e.key === 'Escape' && $drawer.hasClass('is-active')) {
      closeDrawer();
    }
  });

  // Helper function to update mini cart content from fragments
  const updateMiniCartFromFragments = (fragments) => {
    if (!fragments) {
      return;
    }

    // Update the mini cart content using WooCommerce's standard fragment key
    const fragmentKey = 'div.widget_shopping_cart_content';
    if (fragments[fragmentKey]) {
      const $newContent = jQuery(fragments[fragmentKey]);
      const $oldContent = $drawer.find('.widget_shopping_cart_content, .js-mini-cart-content');
      if ($oldContent.length) {
        $oldContent.replaceWith($newContent);
      }
    }

    // Update all other fragments (cart count, etc.)
    jQuery.each(fragments, (key, value) => {
      if (key !== fragmentKey) {
        const $target = jQuery(key);
        if ($target.length) {
          $target.replaceWith(value);
        }
      }
    });
  };

  // Handle WooCommerce cart fragments update
  jQuery(document.body).on('added_to_cart', () => {
    // Refresh mini cart content
    if (typeof wc_add_to_cart_params !== 'undefined') {
      jQuery.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'get_refreshed_fragments'),
        success: (data) => {
          if (data && data.fragments) {
            updateMiniCartFromFragments(data.fragments);
            openDrawer(); // Auto-open drawer when item is added
          }
        }
      });
    }
  });

  // Handle remove from cart
  $drawer.on('click', '.remove_from_cart_button', function(e) {
    const $button = jQuery(this);
    const cartItemKey = $button.data('cart_item_key');

    if (!cartItemKey) {
      return;
    }

    e.preventDefault();

    jQuery.ajax({
      type: 'POST',
      url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_from_cart'),
      data: {
        cart_item_key: cartItemKey
      },
      success: (data) => {
        if (data && data.fragments) {
          updateMiniCartFromFragments(data.fragments);

          // Close drawer if cart is empty
          const $cartItems = $drawer.find('.woocommerce-mini-cart-item');
          if ($cartItems.length === 0) {
            closeDrawer();
          }
        }
      },
      error: () => {
        // Fallback to page reload if AJAX fails
        window.location.reload();
      }
    });
  });

  // Update quantity in mini cart
  $drawer.on('change', '.js-mini-cart-quantity', function() {
    const $input = jQuery(this);
    const quantity = $input.val();
    const cartItemKey = $input.data('cart_item_key');

    if (!cartItemKey) {
      return;
    }

    jQuery.ajax({
      type: 'POST',
      url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'update_cart'),
      data: {
        cart_item_key: cartItemKey,
        quantity: quantity
      },
      success: (data) => {
        if (data && data.fragments) {
          updateMiniCartFromFragments(data.fragments);
        }
      }
    });
  });

  // Ensure mini cart updates when WooCommerce fragments are refreshed elsewhere
  // This handles cases where cart is updated from other parts of the site
  jQuery(document.body).on('wc_fragments_refreshed wc_fragments_loaded', () => {
    // Check if the fragment was already updated in the DOM
    const $fragment = jQuery('div.widget_shopping_cart_content');
    if ($fragment.length && $drawer.find('.widget_shopping_cart_content').length) {
      // Update the drawer content if it exists in the page
      const $newContent = $fragment.first();
      const $oldContent = $drawer.find('.widget_shopping_cart_content, .js-mini-cart-content');
      if ($oldContent.length && $newContent.length) {
        $oldContent.replaceWith($newContent.clone());
      }
    }
  });
};

export { initMiniCart };

